import { render, staticRenderFns } from "./DefectsCategories.vue?vue&type=template&id=0e55056d"
import script from "./DefectsCategories.vue?vue&type=script&lang=js"
export * from "./DefectsCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports